import { MonthView, Scheduler, SchedulerItem, SchedulerItemContent } from "@progress/kendo-react-scheduler";
import React from "react";
import '@progress/kendo-date-math/tz/all';
import * as dates from 'commons/models/dates';
import { useState } from "react";
import { useEffect } from "react";
import { useCallback } from "react";
import { useMemo } from "react";
import LoaderContainer from "commons/container/LoaderContainer";
import { IconWrap } from "@progress/kendo-react-common";
import { caretAltLeftIcon } from "@progress/kendo-svg-icons";
import PropTypes from "prop-types";
import { useGetDiffuseursQuery, useGetThematiqueQuery } from "../../redux/api/cache";

export default function CustomScheduler(props) {
    const [data, setData] = useState(JSON.parse(JSON.stringify(props.data)));
    const { data: diffuseurs, isLoading: isDiffuseursLoading, isFetching: isDiffuseursFetching } = useGetDiffuseursQuery(props.media);
    const { data: thematiques, isLoading: isThematiquesLoading, isFetching: isThematiquesFetching } = useGetThematiqueQuery();
    const customModelFiels = useMemo(() => {
        return {
            id: 'rid',
            title: 'title',
            description: '',
            start: 'debut',
            end: 'fin',
            recurrenceRule: 'RecurrenceRule',
            recurrenceId: 'RecurrenceID',
            recurrenceExceptions: 'RecurrenceException'
        };
    }, []);

    useEffect(() => {
        setData(JSON.parse(JSON.stringify(props.data)));
    }, [props.data]);

    const processData = useMemo(() => {
        let filterList = [];
        data.forEach(item => {
            let temp = filterList.find(f => ((item.diff_cd && f.diff_cd === item.diff_cd) || (item.them_cd && f.them_cd === item.them_cd)) && f.campr_date === item.campr_date && f.mf_format === item.mf_format);
            if (temp === undefined) {
                filterList.push(item);
            }
        });

        return filterList.map(p => {
            p.debut = dates.dateBdToDate(p.campr_date, '00:00');
            p.fin = p.campr_dt_fin ? dates.dateBdToDate(p.campr_dt_fin, '23:59') : dates.dateBdToDate(p.campr_date, '23:59');
            p.title = (p.them_cd ? thematiques?.data.find(item => item.them_cd === p.them_cd)?.them_descr : diffuseurs?.data.find(item => item.diff_cd === p.diff_cd)?.diff_nom) + (p.mf_format ? ` (${p.mf_format})` : "");
            p.isAllDay = true;
            return p;
        });
    }, [data, thematiques, diffuseurs]);

    const getBackgroundColor = (itemProps) => {
        let defaultBackground = "black";

        if (props.selectedRow && props.selectedRow.campr_date === itemProps.dataItem.campr_date && props.selectedRow.mf_format === itemProps.dataItem.mf_format && ((props.selectedRow.diff_cd && props.selectedRow.diff_cd === itemProps.dataItem.diff_cd) || (props.selectedRow.them_cd && props.selectedRow.them_cd === itemProps.dataItem.them_cd)))
            defaultBackground = "#808080";
        else if (props.numeric) {
            if (!itemProps.dataItem.campr_instr_envoi)
                defaultBackground = "black";
            else {
                defaultBackground = "#af0031";
            }
        }

        return defaultBackground;
    };

    const CustomItem = (customItemProps) => {
        const handleClick = useCallback(
            () => {
                props.outputData(customItemProps.dataItem);
            },
            [customItemProps.dataItem]
        );

        return <SchedulerItem {...customItemProps} onClick={handleClick} selected={true} style={{ backgroundColor: getBackgroundColor(customItemProps), transform: 'translateY(35px)' }} >
            <span className="k-event-actions">
                {customItemProps.tail &&
                    (<IconWrap name={'caret-alt-left'} icon={caretAltLeftIcon} />)}
            </span>
            <div title={`${dates.dateFormatDay(customItemProps.start)}-${dates.dateFormatDay(customItemProps.end)}`}>
                <SchedulerItemContent>
                    {customItemProps.title}
                </SchedulerItemContent>
            </div>
        </SchedulerItem>;
    };

    return <>
        {!isDiffuseursFetching && !isDiffuseursLoading && !isThematiquesFetching && !isThematiquesLoading && (<Scheduler timezone="Canada/Eastern" modelFields={customModelFiels} data={processData} item={CustomItem} height={'auto'} ><MonthView itemsPerSlot={Number.MAX_VALUE} /></Scheduler>)}
        {isDiffuseursFetching || isDiffuseursLoading || isThematiquesFetching || isThematiquesLoading && (<LoaderContainer />)}
    </>;
}

CustomScheduler.propTypes = {
    data: PropTypes.any.isRequired,
    media: PropTypes.string.isRequired,
    outputData: PropTypes.any.isRequired,
    numeric: PropTypes.bool.isRequired,
    selectedRow: PropTypes.any.isRequired
};